/*
BASED ON: https://github.com/nolimitdev/vue-html-secure
LICENSE OF SOURCE: https://github.com/nolimitdev/vue-html-secure/blob/master/LICENSE

MIT License

Copyright (c) 2020 nolimitdev

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

END LICENSE OF SOURCE
 */

let doc = document.implementation.createHTMLDocument('');
let div = doc.createElement('div');

function safeHTML(htmlString) {
    if(!htmlString) {
        return '';
    }

    div.innerHTML = htmlString;

    const elements = div.querySelectorAll('*');
    let i = elements.length - 1;
    for(; i >= 0; i--) {
        const element = elements[i],
            tagName = element.localName;

        if(tagName === 'script' || tagName === 'noscript' || tagName === 'noembed' || !(element.attributes instanceof NamedNodeMap)) {
            try {
                element.parentNode.removeChild(element);
            } catch(e) {
                element.outerHTML = '';
            }
            continue;
        }

        if(!element.hasAttributes())
            continue;

        const attributes = element.attributes;
        let j = attributes.length - 1;
        for(; j >= 0; j--) {
            const attribute = attributes[j],
                attributeName = attribute.localName,
                attributeValue = attribute.value.replace(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g, '').toLowerCase().trim();

            // Remove insecure attribute starting "on*" (example: <img src='' onerror=alert(1)>)
            if(attributeName.indexOf('on') === 0)
                element.removeAttribute(attributeName);

            // Remove insecure src/href attribute with value starting "javascript:*" (example: href="javascript:alert(1)")
            else if((attributeName === 'src' || attributeName === 'href') && attributeValue.indexOf('javascript:') === 0)
                element.removeAttribute(attributeName);

            // For non-specific tags remove insecure src/data attribute with value starting "data:*" (example: <embed src="data:text/html;base64,bla">)
            else if(['audio', 'image', 'img', 'source', 'video'].indexOf(tagName) === -1 && (attributeName === 'src' || attributeName === 'data') && attributeValue.indexOf('data:') === 0)
                element.removeAttribute(attributeName);
        }
    }

    return div.innerHTML;
}

module.exports = {
    install: function(Vue) {
        Vue.directive('html-safe', {
            // For Vue 2.x
            inserted: function(el, binding) {
                el.innerHTML = safeHTML(binding.value);
            },

            // For Vue 3.x
            mounted: function(el, binding) {
                el.innerHTML = safeHTML(binding.value);
            },

            // For Vue 2.x
            update: function(el, binding) {
                if(binding.value !== binding.oldValue)
                    el.innerHTML = safeHTML(binding.value);
            },

            // For Vue 3.x
            updated: function(el, binding) {
                if(binding.value !== binding.oldValue)
                    el.innerHTML = safeHTML(binding.value);
            },
        });

    }
}